export const signInPageLabel = {
    defaultMessage: 'Sign In Page Label',
    id: 'oe.website.signInLabel',
    description: 'Label text',
};
export const signInButtonLabel = {
    defaultMessage: 'Sign In button label',
    id: 'oe.website.signInButtonLabel',
    description: 'Label text',
};
export const loginInstructions = {
    defaultMessage: 'Login Instructions',
    id: 'oe.login.instructions',
    description: 'Label text',
};
export const loginErrorMessage = {
    defaultMessage: 'Login Error Message',
    id: 'oe.login.errorMessage',
    description: 'Label text',
};
export const accessCodeHeader = {
    defaultMessage: 'Access Code Header',
    id: 'oe.website.accessCodeHeader',
    description: 'Label text',
};
export const requestAccessCodeButtonLabel = {
    defaultMessage: 'Request Access Code button label',
    id: 'oe.website.requestAccessCodeButtonLabel',
    description: 'Label text',
};
export const accessCodeInstructions = {
    defaultMessage: 'Access Code Instructions',
    id: 'oe.website.accessCodeInstructions',
    description: 'Label text',
};
export const accessCodeRequestedMessage = {
    defaultMessage: 'Access Code Requested Message',
    id: 'oe.website.accessCodeRequestedMessage',
    description: 'Label text',
};
export const navigationButtonLabel = {
    defaultMessage: 'Navigation button label',
    id: 'oe.website.navigationButtonLabel',
    description: 'Label text',
};
export const accessCodeRequestButtonLabel = {
    defaultMessage: 'Access Code Request Button label',
    id: 'oe.website.accessCodeRequestButtonLabel',
    description: 'Label text',
};

export function accessCodeRequestButtonText(isEnabled: boolean) {
    return isEnabled
        ? 'Access Code Request Button is enabled'
        : 'Access Code Request Button is disabled'
    ;
}
export function accessCodeRequestButtonId(isEnabled: boolean) {
    return isEnabled
        ? 'oe.websiteTab.requestButtonTextEnabled'
        : 'oe.websiteTab.requestButtonTextDisabled'
    ;
}

export function buttonNavigationOnAccessCodeSignInPageText(isEnabled: boolean) {
    return isEnabled
        ? 'Button navigation on Access Code Sign In page is enabled'
        : 'Button navigation on Access Code Sign In page is disabled'
    ;
}
export function buttonNavigationOnAccessCodeSignInPageId(isEnabled: boolean) {
    return isEnabled
        ? 'oe.websiteTab.navigationButtonTextEnabled'
        : 'oe.websiteTab.navigationButtonTextDisabled'
    ;
}
